const __WEBPACK_NAMESPACE_OBJECT__ = require("@fortawesome/free-regular-svg-icons");